/* ------------------ SCRIPT LOADING TIMES --------------- */
export const SCRIPT_LOAD_TIME_FULLSTORY = 3500;
export const SCRIPT_LOAD_TIME_ACS = 6500;
export const SCRIPT_LOAD_TIME_CHAT = 10000;
